import type React from 'react';

import { Styled } from './styles';

export type HeroCardProps = {
  className?: string;
  companyName: string;
  logoLink?: string;
  logoImage?: string;
  profileLink: string;
  jobTitle: string;
  name: string;
  profileImage: string;
  tags?: string[];
  highlightInfo?: string;
  onClick?: () => void;
};

export const HeroCard: React.FC<HeroCardProps> = ({
  logoLink,
  logoImage,
  jobTitle,
  profileLink,
  name,
  profileImage,
  tags,
  className,
  companyName,
  highlightInfo,
  onClick,
}) => {
  return (
    <Styled.HeroWrapper className={className} onClick={onClick}>
      <Styled.ContainerWrapper
        $backgroundImage={profileImage || ''}
        data-qa={'hero-card-container'}
      >
        <Styled.TextContainer>
          <Styled.StyledLink href={profileLink}>
            <Styled.TextName size="small" fontWeight="bold">
              {name}
            </Styled.TextName>
          </Styled.StyledLink>
          <Styled.CompanyLink href={logoLink || ''}>
            <Styled.JobTitleContainer>
              {logoImage && (
                <Styled.StyledProfileImage
                  src={logoImage}
                  type="company"
                  size={'small'}
                  data-qa={'hero-card-company-logo'}
                />
              )}
              <Styled.TextJobTitleContainer>
                <Styled.TextJobTitle size="small" lineHeight="dense">
                  {jobTitle}
                </Styled.TextJobTitle>
                <Styled.TextJobTitle size="small" lineHeight="dense">
                  {companyName}
                </Styled.TextJobTitle>
              </Styled.TextJobTitleContainer>
            </Styled.JobTitleContainer>
          </Styled.CompanyLink>
        </Styled.TextContainer>
      </Styled.ContainerWrapper>
      <Styled.TagsContainer data-qa={'hero-card-tags'}>
        {tags?.map((tag) => {
          return (
            <Styled.StyledTag
              key={`hero-card-${tag}`}
              data-qa={`hero-card-${tag}`}
            >
              {tag}
            </Styled.StyledTag>
          );
        })}
      </Styled.TagsContainer>
      {highlightInfo && (
        <Styled.HighlightInfoWrapper>
          <Styled.HighlightInfoIcon width={24} height={24} />
          <Styled.HighlightInfo size="small">
            {highlightInfo}
          </Styled.HighlightInfo>
        </Styled.HighlightInfoWrapper>
      )}
    </Styled.HeroWrapper>
  );
};
